import 'babel-polyfill'
import Vue from 'vue'
import Cookies from 'js-cookie'

import install from './element-install'
import App from './App'
import store from './store'
import router from './router'

import * as Sentry from '@sentry/vue'
import { BrowserTracing } from '@sentry/tracing'

// global components
import SearchPanel from '@/components/search-panel'
import Collapse from '@/components/collapse'

import './permission' // permission control
import '@/icons' // icon

import '@/styles/element-variables.scss'
import 'normalize.css/normalize.css'
import '@/styles/index.scss'

// element-ui install
install(Vue, {
  size: Cookies.get('size') || 'mini' // set element-ui default size
})

// 查询收缩面板
Vue.component(SearchPanel.name, SearchPanel)
Vue.component(Collapse.name, Collapse)

Vue.config.productionTip = false


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})


console.log('APP_ENV:' + APP_ENV)
if (APP_ENV === 'PROD' || APP_ENV === 'PREPROD') {
  // 線上環境
  Sentry.init({
    Vue,
    dsn: 'https://7dcf5fecfd9b4af793a1bfacc72c4685@cloud-sentry-front.goldentec.com:8443/187',
    integrations: [
      new BrowserTracing({
        routingInstrumentation: Sentry.vueRouterInstrumentation(router)
      }),
    ],
    tracesSampleRate: 1.0,
  })
}
